import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

/**
 * Formly field type for a hex color, via the browser's native <input type="color"> picker --
 * no third-party color-picker library in this app (see CLAUDE.md's third-party UI policy),
 * and the native control needs no extra JS to give a real swatch + OS picker.
 *
 * Props:
 * - label: string - Field label
 * - description: string - Helper text
 */
@Component({
  selector: 'app-color-field',
  imports: [ReactiveFormsModule, FormlyModule],
  templateUrl: './color-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './color-field.component.css',
})
export class ColorFieldComponent extends FieldType<FieldTypeConfig> {}
